import styled from 'styled-components';
import { colors } from '~/styles/remoteControlColors';

export const ReasonButtonContainer = styled.button`
  border: 0;
  margin: 0;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.Grey200};
  width: 100%;
  border-radius: 4px;
  height: 40px;
  cursor: pointer;

  & > p {
    margin: 0;
    color: ${colors.Grey500};
    font-size: 14px;
    font-weight: 700;
  }

  svg {
    margin-left: auto;
  }
`;

export const ReasonListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  gap: 16px;
  width: 100%;

  & > p {
    font-size: 16px;
    font-weight: 500;
    color: ${colors.Grey400};
    margin-bottom: 16px;
  }
`;
